<template>
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="bg-white br-30 br-sm-60 br-lg-90 p-5 sh-1 info-basic">
        <div v-if="!loading && details" class="row align-items-sm-center">
          <div class="col-12">
            <router-link :to="`/evaluations`">{{ $t('default.evaluations.go-back') }}</router-link>
          </div>
          <div class="col-12 mb-5 text-center">
            <div><strong>{{ details.groupData.group }} - {{ $helpers.getLocalizedField(details.groupData, 'subject') }}</strong></div>
            <div>{{ $helpers.getLocalizedField(details, 'RatesType') }}
              ({{ $t('default.evaluations.weeks.week') }}
              №{{ details.week }})
             
              {{ $t('default.evaluations.min') }}: {{ details.barriers.min }}
              {{ $t('default.evaluations.max') }}: {{ details.barriers.max }}
            </div>
          </div>
          <div class="col-12">
            <group-presentation-evaluations :loading="loading"
                                            :details="details"
                                            @save-evaluation="saveEvaluation"
                                            v-if="parseInt(details.RatesDetailID) === 3 && parseInt(details.groupData.presentation_upload)"></group-presentation-evaluations>
<!--            <group-exam-evaluations :loading="loading" :details="details" @click="saveEvaluation" v-else-if="parseInt(details.RatesDetailID) === 4"></group-exam-evaluations>-->
            <group-quiz-evaluations :loading="loading"
                                    :details="details"
                                    @save-evaluation="saveEvaluation"
                                    v-else></group-quiz-evaluations>
          </div>
        </div>
        <div class="row" v-if="loading">
          <div class="col-12 text-center my-5">
            <three-dots></three-dots>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EvaluationResource from '../../api/evaluationResource'
import ThreeDots from 'vue-loading-spinner/src/components/ThreeDots'
import GroupPresentationEvaluations from './GroupPresentationEvaluations'
import GroupQuizEvaluations from './GroupQuizEvaluations'

const evaluationResource = new EvaluationResource()

export default {
  name: 'GroupWeekEvaluations',

  components: { GroupPresentationEvaluations, GroupQuizEvaluations, ThreeDots },

  data () {
    return {
      details: null,
      loading: false
    }
  },

  mounted () {
    this.loadEvaluations()
  },

  methods: {
    saveEvaluation ({ type, studentId, rateComponentId, point }) {

     
      point = parseFloat(point)
      if (isNaN(point)) point = 0
      evaluationResource.saveEvaluation(this.details.group, studentId, rateComponentId, point, this.details.week)
        .then(response => {
          this.loadEvaluations()
        })
        .catch(error => {
          this.$helpers.notifyErrorMessage(error)
        })
    },

    loadEvaluations () {
 
   
      this.loading = true
      evaluationResource.evaluationDetails(this.$route.params.group, this.$route.params.week,this.$route.params.componentRequestID)
        .then(response => {
          this.details = response.data.data
          
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
